//#region src/dom.render-download-throbber.ts
var activeCanvases = /* @__PURE__ */ new Set();
function renderDownloadThrobber(canvas, { drawCircle = true, drawDurationMs = 3300, color = "#ddd", sizePx = 64 } = {}) {
	const ctx = canvas === null || canvas === void 0 ? void 0 : canvas.getContext("2d");
	if (!canvas || !ctx || activeCanvases.has(canvas)) return;
	activeCanvases.add(canvas);
	const pixelRatio = window.devicePixelRatio ?? 1;
	canvas.style.cssText = `
    position: absolute;
    top: calc(50% - ${sizePx / 2}px);
    left: calc(50% - ${sizePx / 2}px);
    height: ${sizePx}px;
    width: ${sizePx};
  `;
	canvas.width = sizePx * pixelRatio;
	canvas.height = sizePx * pixelRatio;
	ctx.fillStyle = color;
	ctx.strokeStyle = color;
	ctx.lineWidth = sizePx / BASE_SIZE_PX * pixelRatio;
	const startAnimationAt = Date.now() + (drawCircle ? drawDurationMs / 33 * 8 : 0);
	const onAnimationFrame = () => {
		const iteration = Math.ceil((Date.now() - startAnimationAt) / drawDurationMs);
		const p = (Date.now() - startAnimationAt) % drawDurationMs / drawDurationMs;
		drawThrobber(canvas, ctx, {
			p,
			iteration,
			sizePx: sizePx * pixelRatio,
			drawingRelativePx: sizePx * pixelRatio / BASE_SIZE_PX
		});
		if (canvas.isConnected) requestAnimationFrame(onAnimationFrame);
		else activeCanvases.delete(canvas);
	};
	onAnimationFrame();
}
function drawThrobber(canvas, ctx, config) {
	ctx.save();
	try {
		canvas.style.transform = "";
		for (const segment of ANIMATION_SEGMENTS) if (config.p >= segment.from && config.p <= segment.to) {
			const segmentP = (config.p - segment.from) / (segment.to - segment.from);
			switch (segment.type) {
				case "drawCircle":
					drawCircle(ctx, segmentP, config);
					return;
				case "drawArrow":
					drawArrow(ctx, segmentP, config);
					return;
				case "drawShapes":
					drawShapes(ctx, segmentP, config);
					return;
				case "rotate":
					rotate(canvas, ctx, segmentP, config);
					return;
			}
		}
	} finally {
		ctx.restore();
	}
}
function drawCircle(ctx, p, config) {
	ctx.clearRect(0, 0, config.sizePx, config.sizePx);
	ctx.beginPath();
	ctx.arc(config.sizePx / 2, config.sizePx / 2, config.sizePx / 2 - config.drawingRelativePx, Math.PI * -.5, Math.PI * -.5 + Math.PI * 2 * easeInOutQuart(p));
	ctx.stroke();
}
function drawArrow(ctx, p, config) {
	drawCircle(ctx, 1, config);
	ctx.beginPath();
	ctx.arc(config.sizePx / 2, config.sizePx / 2, config.sizePx / 2 - config.drawingRelativePx, 0, Math.PI * 2);
	ctx.clip();
	const offsetFrom = -13 * config.drawingRelativePx;
	const offsetTo = BASE_SIZE_PX * config.drawingRelativePx;
	let offset;
	if (p < .35) offset = offsetFrom + (offsetTo - offsetFrom) / 2 * easeInOutQuart(p / .35);
	else if (p < .65) offset = offsetFrom + (offsetTo - offsetFrom) / 2;
	else offset = offsetFrom + (offsetTo - offsetFrom) / 2 + (offsetTo - offsetFrom) / 2 * easeInOutQuart((p - .65) / .35);
	ctx.beginPath();
	ctx.moveTo(config.drawingRelativePx * 13, offset);
	ctx.lineTo(config.drawingRelativePx * 13, config.drawingRelativePx * 7 + offset);
	ctx.lineTo(config.drawingRelativePx * 10, config.drawingRelativePx * 7 + offset);
	ctx.lineTo(config.drawingRelativePx * 16, config.drawingRelativePx * 13 + offset);
	ctx.lineTo(config.drawingRelativePx * 22, config.drawingRelativePx * 7 + offset);
	ctx.lineTo(config.drawingRelativePx * 19, config.drawingRelativePx * 7 + offset);
	ctx.lineTo(config.drawingRelativePx * 19, offset);
	ctx.lineTo(config.drawingRelativePx * 13, offset);
	ctx.closePath();
	ctx.fill();
}
function drawShapes(ctx, p, config) {
	drawCircle(ctx, 1, config);
	for (const shape of ANIMATION_SHAPES) {
		const shapeP = Math.max(0, Math.min((easeInOutQuart(p) - shape.delay) / shape.duration, 1));
		switch (shape.type) {
			case "rect":
				drawRect(ctx, shape.x1, shape.y1, shape.x2, shape.y2, shapeP, config);
				continue;
			case "line":
				drawLine(ctx, shape.x1, shape.y1, shape.x2, shape.y2, shapeP, config);
				continue;
		}
	}
}
function rotate(canvas, ctx, p, config) {
	drawCircle(ctx, 1, config);
	if (p < .5) drawShapes(ctx, 1, config);
	const axis = config.iteration % 2 ? "rotateY" : "rotateX";
	const rotation = Math.round(easeInOutQuart(p) * 180);
	canvas.style.transform = `${axis}(${rotation}deg)`;
}
function drawRect(ctx, x1, y1, x2, y2, p, config) {
	const x = x1 * config.drawingRelativePx;
	const y = y1 * config.drawingRelativePx;
	const w = (x2 - x1) * config.drawingRelativePx;
	const h = (y2 - y1) * config.drawingRelativePx;
	ctx.globalAlpha = p;
	ctx.fillRect(x + w * (1 - p) / 2, y + h * (1 - p) / 2, w * p, h * p);
	ctx.globalAlpha = 1;
}
function drawLine(ctx, x1, y1, x2, y2, p, config) {
	ctx.beginPath();
	ctx.moveTo(x1 * config.drawingRelativePx, (y1 + .5) * config.drawingRelativePx);
	ctx.lineTo((x1 + (x2 - x1) * p) * config.drawingRelativePx, (y1 + .5 + (y2 - y1) * p) * config.drawingRelativePx);
	ctx.stroke();
}
var BASE_SIZE_PX = 32;
var ANIMATION_SEGMENTS = [
	{
		from: -8 / 33,
		to: 0,
		type: "drawCircle"
	},
	{
		from: 0,
		to: 11 / 33,
		type: "drawArrow"
	},
	{
		from: 12 / 33,
		to: 24 / 33,
		type: "drawShapes"
	},
	{
		from: 25 / 33,
		to: 32 / 33,
		type: "rotate"
	}
];
var ANIMATION_SHAPES = [
	{
		type: "rect",
		x1: 7,
		y1: 7,
		x2: 14,
		y2: 14,
		delay: 0,
		duration: .625
	},
	{
		type: "line",
		x1: 15,
		x2: 22,
		y1: 7,
		y2: 7,
		delay: .15,
		duration: .675
	},
	{
		type: "line",
		x1: 15,
		x2: 25,
		y1: 9,
		y2: 9,
		delay: .175,
		duration: .8
	},
	{
		type: "line",
		x1: 15,
		x2: 26,
		y1: 11,
		y2: 11,
		delay: .125,
		duration: .575
	},
	{
		type: "line",
		x1: 15,
		x2: 20,
		y1: 13,
		y2: 13,
		delay: .15,
		duration: .6
	},
	{
		type: "line",
		x1: 7,
		x2: 25,
		y1: 15,
		y2: 15,
		delay: 0,
		duration: 1
	},
	{
		type: "line",
		x1: 7,
		x2: 26,
		y1: 17,
		y2: 17,
		delay: 0,
		duration: .65
	},
	{
		type: "line",
		x1: 7,
		x2: 17,
		y1: 19,
		y2: 19,
		delay: 0,
		duration: .775
	},
	{
		type: "line",
		x1: 7,
		x2: 25,
		y1: 21,
		y2: 21,
		delay: 0,
		duration: 1
	},
	{
		type: "line",
		x1: 7,
		x2: 24,
		y1: 23,
		y2: 23,
		delay: 0,
		duration: .825
	},
	{
		type: "line",
		x1: 7,
		x2: 19,
		y1: 25,
		y2: 25,
		delay: 0,
		duration: .875
	}
];
function easeInOutQuart(argP) {
	function easeInQuart(p) {
		return Math.pow(p, 4);
	}
	const p = Math.max(0, Math.min(1, argP));
	return p < .5 ? easeInQuart(p * 2) / 2 : 1 - easeInQuart(p * -2 + 2) / 2;
}
//#endregion
export { renderDownloadThrobber };

//# sourceMappingURL=dom.render-download-throbber.js.map